import React from "react";
import TeamTitle from "../../components/title/TeamTitle";
import { CardBody, CardContainer, CardHeader } from "best-common-react";
import InvestigationProtected from "../../components/protected/InvestigationProtected";
import InvestigationsFilters from "../../components/investigations/InvestigationsFilters";
import InvestigationsFooter from "../../components/investigations/InvestigationsFooter";
import LoadingSpinner from "../../components/loading/LoadingSpinner";

function InvestigationsContainer() {
  return (
    <div>
      <TeamTitle disabled={true} />
      <LoadingSpinner />
      <CardContainer>
        <CardHeader>Investigations</CardHeader>
        <CardBody>
          <InvestigationsFilters />
          <InvestigationsFooter />
        </CardBody>
      </CardContainer>
    </div>
  );
}

export default InvestigationProtected(InvestigationsContainer);
